module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBestseller@2x.d5b870c.jpg";